import { render, staticRenderFns } from "./dataSelect.vue?vue&type=template&id=2b6506a3&scoped=true"
import script from "./dataSelect.vue?vue&type=script&lang=ts"
export * from "./dataSelect.vue?vue&type=script&lang=ts"
import style0 from "./dataSelect.vue?vue&type=style&index=0&id=2b6506a3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6506a3",
  null
  
)

export default component.exports